import React, { useContext } from "react";
import "./RecentEntries.css";

import RecentEntriesTable from "./RecentEntriesTable";
import FilterTable from "./FilterTable";
import FormContext from "../../../context/FormContext";

const RecentEntries = () => {
  const { filterEntry } = useContext(FormContext);

  return (
    <div className="operator-entries-container">
      {filterEntry ? <FilterTable /> : <RecentEntriesTable />}
    </div>
  );
};

export default RecentEntries;
